'use client'

import { Button } from '@vinted/web-ui'

import { useAuthModal } from '@marketplace-web/auth-flow/auth-modal-context-feature'

const SignupButton = (props: React.ComponentProps<typeof Button>) => {
  const { openAuthModal } = useAuthModal()

  const handleClick = () => {
    openAuthModal({ isBusiness: true })
  }

  return <Button {...props} styling="filled" onClick={handleClick} />
}

export default SignupButton
